// extracted by mini-css-extract-plugin
export default {"popover":"Popover_popover__Jgv-M","popoverContent":"Popover_popoverContent__6ElEJ","parent":"Popover_parent__IoV5n"};